{
    "NAME": "GerätetypenSprache",
    "DeviceTypesLanguage_Unknown": "Unbekannt",
    "DeviceTypesLanguage_Trunk": "Stamm",
    "DeviceTypesLanguage_TrunkGateway": "Trunk-Gateway",
    "DeviceTypesLanguage_ChatService": "Chat-Dienst",
    "DeviceTypesLanguage_EmailServer": "E-Mail-Server",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Erweiterung \/ Endpunkt",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Erweiterung (Trunking)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Erweiterung (Gastgewerbe)",
    "DeviceTypesLanguage_GroupSuper": "Supergruppe",
    "DeviceTypesLanguage_GroupCollective": "Gruppe (Kollektiv)",
    "DeviceTypesLanguage_GroupLinear": "Gruppe (Linear)",
    "DeviceTypesLanguage_GroupCyclic": "Gruppe (zyklisch)",
    "DeviceTypesLanguage_GroupAcd": "Gruppe (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Gruppe (Stamm)",
    "DeviceTypesLanguage_GroupVoicemail": "Gruppe (Voicemail)",
    "DeviceTypesLanguage_GroupPage": "Gruppe (Seite)",
    "DeviceTypesLanguage_GroupDepartment": "Abteilung",
    "DeviceTypesLanguage_GroupSecurityGroup": "Sicherheitsgruppe",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Dienstleistergruppen",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Anrufwarteschlangen",
    "DeviceTypesLanguage_Park": "Park",
    "DeviceTypesLanguage_VoicemailApplication": "Voicemail-Anwendung",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Warteschlangenansage (Jagdgruppe)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Warteschlangenansage (Allgemein)",
    "DeviceTypesLanguage_AutoAttendant": "Automatischer Anrufbeantworter",
    "DeviceTypesLanguage_MusicOnHold": "Wartemusik",
    "DeviceTypesLanguage_Conference": "Konferenz",
    "DeviceTypesLanguage_PilotNumber": "Pilot \/ Alternative",
    "DeviceTypesLanguage_DnisEntry": "DNIS-Eintrag"
}